define('viewmodels/pages/changePassword',['knockout', 'bluebird'], function (ko, Promise) {

    var ChangePasswordViewModel = function (changePasswordModel, getField, ForgotPasswordDialog, formFields) {
        var self = this;

        self.passwordFieldLabel = getField('password_field_label');
        self.changePasswordButtonText = getField('change_password_button_text');
        self.successMessage = getField('success_message');
        self.loginButtonText = getField('log_in_button_text');
        self.tokenInvalidMessage = getField('security_token_invalid_message');
        self.resendLinkButtonText = getField('resend_email_button_text');

        self.securityToken = changePasswordModel.token;
        self.passwordChanged = ko.observable(false);
        self.passwordField = formFields.passwordField(changePasswordModel.newPassword);
        self.changePasswordCommand = changePasswordModel.createCommand();

        self.resendLink = function () {
            (new ForgotPasswordDialog()).show();
        };
    };

    ChangePasswordViewModel.prototype.changePassword = function () {
        var self = this;

        self.changePasswordCommand.dispatch().then(function (response, command) {
            command.reset();
            self.passwordChanged(true);
        });
    };

    ChangePasswordViewModel.prototype.canActivate = function (tokenId) {
        // before we load the page first wait until we have validated the token
        var self = this;

        return new Promise(function (resolve) {
            var stateSubscription = self.securityToken.state.subscribe(function (state) {
                if (state !== self.securityToken.STATE_LOADING) {
                    resolve(true);
                    stateSubscription.dispose();
                }
            });

            self.securityToken.tokenId(tokenId);
        });
    };

    return ChangePasswordViewModel;
});

